import React from 'react';
import { AuditsTable } from '../../Agreement/Table/AgreementAuditsTable';

export default function AgreementTemplateAuditsTable() {
    return <AuditsTable statusChoiceList="addendumStatus" />;
}
